import { ImageProps } from 'next/image';

// External image domains that should skip optimization
const STRAPI_DOMAINS = ['wonderful-dogs-8ceb8899a2.media.strapiapp.com'];

const WORDPRESS_DOMAINS = [
  'iminblog.kinsta.cloud',
  'headlesswordpressgf.kinsta.cloud',
  'immigrantinvest.com/wp-content',
  '/wp-content/'
];

// File extensions that should skip optimization
const SKIP_OPTIMIZATION_EXTENSIONS = ['.svg', '.gif'];

// Local paths that should skip optimization
const SKIP_OPTIMIZATION_PATHS = ['/images/icons/', '/images/flags/'];

export const shouldSkipOptimization = (src: ImageProps['src']): boolean => {
  if (typeof src === 'string') {
    // Skip optimization for Strapi images (high volume, already optimized)
    if (STRAPI_DOMAINS.some(domain => src.includes(domain))) {
      return true;
    }

    // Skip optimization for WordPress images (already optimized by WordPress)
    if (WORDPRESS_DOMAINS.some(domain => src.includes(domain))) {
      return true;
    }

    // Skip optimization for specific file extensions
    if (SKIP_OPTIMIZATION_EXTENSIONS.some(ext => src.endsWith(ext))) {
      return true;
    }

    // Skip optimization for specific local paths
    if (SKIP_OPTIMIZATION_PATHS.some(path => src.startsWith(path))) {
      return true;
    }
  }
  return false;
};

// Keep backward compatibility
export const isStrapiImage = (src: ImageProps['src']): boolean => {
  if (typeof src === 'string') {
    return STRAPI_DOMAINS.some(domain => src.includes(domain));
  }
  return false;
};

export const isWordPressImage = (src: ImageProps['src']): boolean => {
  if (typeof src === 'string') {
    return WORDPRESS_DOMAINS.some(domain => src.includes(domain));
  }
  return false;
};
